import { NotifyHelper } from "../../../helpers/toast";
import { eInBangDiemActionsObj } from "../../action-types/in-bang-diem/IInBangDiemActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const inBangDiemActions = {
    ...generateActions(eInBangDiemActionsObj, "IN_BANG_DIEM"),
    ...generateActionForKey(eInBangDiemActionsObj, "IN_BANG_DIEM" , "LOAD_BANG_DIEM_ERROR", (m) => { NotifyHelper.Error(m.data) }),
}